import $ from 'jquery'
import Screen from './screen'

export default class Cases {
  init() {
    const screen = new Screen()

    // resize PC
    $(window).on('breakpointChange', function () {
      if (screen.isPC) {
        $('.js-accd-article').removeClass('is-active')
        $('.interview-box__article-accd').removeAttr('style')
      }
    })

    $(function () {
      accdArticleSP()
    })

    var accdArticleSP = function () {
      $('.js-accd-article').on('click', function () {
        if (!screen.isPC) {
          if (!$(this).hasClass('is-active')) {
            $(this).addClass('is-active').next().stop().slideDown()
          } else {
            $(this).removeClass('is-active').next().stop().slideUp()
          }
        }
      })
    }
  }
}
